import React, { useState, useEffect, useContext } from 'react';
import axiosConfig from '../../../utils/axiosConfig';
import MUIDataTable from 'mui-datatables';
import { StateContext, DispatchContext } from '../../../context/Provider';
import { IconButton, Tooltip } from '@material-ui/core';

import { 
    BackspaceTwoTone as BackspaceTwoToneIcon,
    Delete as DeleteIcon,
    DeleteForeverTwoTone as DeleteForeverTwoToneIcon,
    Edit as EditIcon,
    VerifiedUserTwoTone as VerifiedUserTwoToneIcon
} from '@material-ui/icons';

import ResponsiveLayout from '../../Layouts/ResponsiveLayout';
import BackdropLoader from '../../../components/Shared/BackdropLoader/BackdropLoader';
import StudentModalForm from './Modals/StudentModalForm';
import Toolbar from './Toolbar/Toolbar';

const Students = (props) => {
    const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);
    const { globalState, authState } = appState;
    const { globalDispatch } = appDispatch;

    const [open, setOpen] = useState(false);
    const [selectedStudent, setSelectedStudent] = useState(null);

    const [isMounted, setisMounted] = useState(true);
 
    const [options, setOptions] = useState({
        filter: true,
        filterType: 'dropdown',
        responsive: 'simple',
        rowsPerPage: 10,
        selectableRows: false, // turn off checkbox in rows
        customToolbar: () => {
            return (<Toolbar fetchStudents={fetchStudents} />);
        }
    });

    const [columns, setColumns] = useState([
        { label: "#", name: "id", options: { display: true } },
        { label: "Avatar", name: "avatar",
            options: { 
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <img 
                            src={value}
                            width="50px"
                            height="50px"
                        />
                    );
                }
            }
        },
        { label: "Name", name: "name", options: { display: true } },
        { label: "LRN", name: "lrn", options: { display: true } },
        { label: "Email", name: "email", options: { display: true } },
        { label: "Status", name: "status", options: { display: true } },
        { label: "Date Created", name: "created_at", options: { display: true } },
        { label: "Last Login", name: "last_login_at", options: { display: true } },
        { label: 'Actions', name: "actions",
            options: { 
                customBodyRender: (value, tableMeta, updateValue) => {

                    let currentStatus = tableMeta.rowData[5];
                    let statusMsg = 'Deactivate';
                    let icon = <BackspaceTwoToneIcon fontSize="small" />;

                    if (currentStatus !== 'Active') {
                        statusMsg = 'Activate';
                        icon = <VerifiedUserTwoToneIcon fontSize="small" />;
                    }

                    const actionIcon = (
                        <Tooltip title={statusMsg}>
                            {icon}
                        </Tooltip>
                    );

                    return (
                        <>
                            <IconButton 
                                aria-label="edit" 
                                onClick={() => handleClick(tableMeta)}
                            >
                                <Tooltip title="Edit">
                                    <EditIcon fontSize="small" />
                                </Tooltip>
                            </IconButton>
                            <IconButton 
                                aria-label="delete" 
                                onClick={() => { 
                                    window.confirm(`Are you sure you want to ${statusMsg} this item?`) && removeItem(tableMeta) 
                                }}>
                                {actionIcon}
                            </IconButton>
                            { authState.user.role_id === 1 && (
                                <IconButton 
                                    aria-label="delete" 
                                    onClick={() => { 
                                        window.confirm(`Are you sure you want to Force Delete this student?`) && forceDelete(tableMeta) 
                                    }}>
                                    <Tooltip title="Force Delete">
                                        <DeleteForeverTwoToneIcon fontSize="default" />
                                    </Tooltip>
                                </IconButton>
                            )}
                        </>
                    )
                }
            }
        }
    ]);

    const [students, setStudents] = useState([]);

    async function fetchStudents() {

        try {
            const response = await axiosConfig.get(`/students`); 
            const { data } = response.data;

            console.log(data);
            if (isMounted) {
                setStudents(data);
            }

        } catch (e) {
            console.log(e);
        }

        globalDispatch({ type: "setIsLoading", value: false});
    }

    async function removeItem(tableMeta) {
        const userID = tableMeta.rowData[0];

        try {
            const response = await axiosConfig.post(`/students/${userID}`, {
                _method: "DELETE"
            }); 

            const { status_code, message } = response.data;

            if (status_code == 'ok') {
                fetchStudents();
            }

        } catch (e) {
            console.log(e);
        }
    }

    async function forceDelete(tableMeta) {
        const userID = tableMeta.rowData[0];
        console.log(userID);

        try {
            const response = await axiosConfig.post(`/forceDeleteUser`, {
                user_id: userID
            });

            const { status_code, message } = response.data;

            if (status_code === 'ok') {
                globalDispatch({type: 'setSnackbarMsg', value: 'Student deleted successfully.'});
                globalDispatch({type: 'setIsOpenSnackbar', value: true});
                fetchStudents();
            }

            globalDispatch({type: 'setIsLoading', value: false});
            setTimeout(() => {
                globalDispatch({type: 'setIsOpenSnackbar', value: false});
            }, 1200);

        } catch (e) {
            console.log(e);
        }
    }

    const handleClick = (tableMeta) => {

        setSelectedStudent({
            id: tableMeta.rowData[0],
            name: tableMeta.rowData[2],
            lrn: tableMeta.rowData[3],
            email: tableMeta.rowData[4]
        });

        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
    }

    useEffect(() => {

        globalDispatch({ type: "setIsLoading", value: true});
        const source = axiosConfig.CancelToken.source();

        fetchStudents();

        return () => {
            setisMounted(false);
            source.cancel();
        }

    }, []);

    return (
        <ResponsiveLayout>
            <StudentModalForm
                dialogTitle={'Edit Student'}
                open={open}
                handleClose={handleClose}
                fetchStudents={fetchStudents}
                selectedStudent={selectedStudent}
            />

            <MUIDataTable 
                title={"List of Students"} 
                data={students} 
                columns={columns} 
                options={options} 
            />
        </ResponsiveLayout>
    );

}

export default Students;